<template>
  <div id="FactRetirementPlan" class="section">
    <div class="columns is-centered is-multiline is-mobile">
      <!-- PERSONAL INFO. -->
      <div class="column is-6-desktop is-12-tablet is-12-mobile">
        <p class="title is-4 has-text-left">ข้อมูลแผนเกษียณ</p>
        <div class="columns has-text-left">
          <div class="column">
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="อายุปัจจุบัน">
                  <b-input
                    type="number"
                    min="0"
                    v-model="current_age"
                    disabled
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="อายุเกษียณ">
                  <b-input type="number" min="0" v-model="retire_age" />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="อายุขัย">
                  <b-input type="number" min="0" v-model="life_age" />
                </b-field>
              </div>
              <div class="column is-6">
                <b-field label="เงินที่ใช้ต่อเดือน">
                  <b-input type="number" min="0" v-model="monthly_expense" />
                </b-field>
              </div>
              <div class="column is-6">
                <b-field label="เงินเก็บเดือนละ">
                  <b-input type="number" min="0" v-model="monthly_saving" />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="% ผลตอบแทนเฉลี่ย / ปี (ก่อนเกษียณ)">
                  <b-input
                    type="number"
                    min="0"
                    max="100"
                    v-model="profit_before_retire"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="% ผลตอบแทนเฉลี่ย / ปี (หลังเกษียณ)">
                  <b-input
                    type="number"
                    min="0"
                    max="100"
                    v-model="profit_after_retire"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="เงินเฟ้อ (%)">
                  <b-input
                    type="number"
                    min="0"
                    max="100"
                    v-model="inflation_rate"
                  />
                </b-field>
              </div>
            </div>
            <b-checkbox v-model="include_inflation">
              จำลองกองทุนเกษียณด้วยกานนำผลตอบแทน(หลังเกษียณ) รวมกับเงินเฟ้อ
            </b-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-mt">
      <div class="columns is-centered">
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            class="prompt-font"
            @click.prevent="backwardStep()"
            >ย้อนกลับ
          </b-button>
        </div>
        <div v-if="edited" class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="updateFactInfoState()"
          >
            บันทึก
          </b-button>
        </div>
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="saveFactInfoState()"
          >
            ต่อไป
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from "@/utils/Helper";
import { mapState, mapMutations } from "vuex";

export default {
  name: "FactRetirementPlan",
  props: ["edited"],
  computed: {
    ...mapState(["client", "factsheet_retirement"]),
    current_age: function() {
      if (this.client) {
        return Helpers.ageCalculator(this.client.dob);
      }
      return null;
    }
  },
  data() {
    return {
      retire_age: null,
      life_age: null,
      inflation_rate: null,
      monthly_expense: null,
      monthly_saving: null,
      profit_before_retire: null,
      profit_after_retire: null,
      include_inflation: false
    };
  },
  methods: {
    ...mapMutations({
      setFactSheetRetirement: "SET_FACTSHEET_RETIREMENT"
    }),
    /* For Display Existing Information */
    setUpRetirementInfo(retirement_info) {
      this.retire_age = retirement_info.target_retirement_age;
      this.life_age = retirement_info.target_life_age;
      this.inflation_rate = retirement_info.inflation_percent;
      this.monthly_expense = retirement_info.monthly_expense_before_retire;
      this.monthly_saving = retirement_info.monthly_saving_amt;
      this.profit_before_retire = retirement_info.percent_profit_before_retire;
      this.profit_after_retire = retirement_info.percent_profit_after_retire;
      this.include_inflation = retirement_info.include_inflation_flag;
    },
    /* Button Action Handler */
    saveFactInfoState: function() {
      if (!this.edited) {
        let plan_retirement = this.createFactInfoRetirementObject();
        this.setFactSheetRetirement(plan_retirement);
      }
      this.$emit("form_completed");
    },
    updateFactInfoState: function() {
      if (this.edited) {
        let plan_retirement = this.createFactInfoRetirementObject();
        this.setFactSheetRetirement(plan_retirement);
        this.$emit("existing_sheet_updated");
      }
    },
    backwardStep: function() {
      this.$emit("back");
    },
    /* API & PARAMS */
    createFactInfoRetirementObject: function() {
      const plan_retirement = {
        target_retirement_age: +this.retire_age,
        target_life_age: +this.life_age,
        monthly_expense_before_retire: +this.monthly_expense,
        monthly_saving_amt: +this.monthly_saving,
        percent_profit_before_retire: +this.profit_before_retire,
        percent_profit_after_retire: +this.profit_after_retire,
        inflation_percent: +this.inflation_rate,
        include_inflation_flag: this.include_inflation
      };
      return plan_retirement;
    }
  },
  beforeMount() {
    if (this.edited) {
      this.setUpRetirementInfo(this.factsheet_retirement);
    }
  }
};
</script>

<style scoped>
.is-align-end {
  align-items: flex-end;
}
</style>
